import constants from './constants';

export default {
  bodyBg: '#ffffff',
  colors: {
    primary: '#6818EB',
    secondary: '#1B81A1',
    accent: '#F9F871'
  },
  textColors: {
    primary: '#ECECE0',
    secondary: '#222222'
  },
  fonts: {
    primary: `'Roboto', sans-serif`
  },
  shadows: ['0 0 10px rgba(0,0,0,0.5)', '0 3px 10px rgba(0,0,0,0.6)'],
  shadowColor: 'rgba(0,0,0,0.5)',
  ...constants
};
